<template>
  <SmallSquare content='核销码管理：核销码管理提供核销码批量管理操作功能
  码包下载说明：支持两种核销码下载方式：1.二维码链接包方式为excel格式，最多一次下载支持2万条数据。
  2.二维码码包方式为二维码图片，最多一次下载支持200条数据' :padding='true'></SmallSquare>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" style="margin-bottom: 25px;"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item class='mb15' label="关键词" name='keywords'>
          <a-input style="width: 350px" v-model:value="search.keywords" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="门店类型" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'160px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">有</a-select-option>
            <a-select-option value="beijing">无</a-select-option>
          </a-select>
        </a-form-item>
        
        <a-form-item label="门店状态" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'160px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">已绑定</a-select-option>
            <a-select-option value="beijing">未绑定</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="所属经销商" name='keywords'>
          <a-input v-model:value="search.keywords"  readonly placeholder='请选择所属经销商' />
        </a-form-item>
        <a-form-item label="" name=''>
          <a-button type="primary">选择</a-button>
        </a-form-item>
        <a-form-item class='mb15' style="width:555px" label="门店地址" name='keywords'>
          <a-row :gutter="16" style="width:100%">
            <a-col :span="12">
              <a-cascader v-model:value="search.address"
                :field-names="{ label: 'name', value: 'id', children: 'children' }" :options="cityList"
                placeholder="请选择门店地址" @change="onChangeAddress" />
            </a-col>
            <a-col :span="12">
              <a-input style="width: 250px" v-model:value="search.keywords" placeholder="请输入详细地址" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="店码状态" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'160px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">有</a-select-option>
            <a-select-option value="beijing">无</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id'
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns'
        :data-source='data'>
        <template v-slot:status='{ record }'>
          <a-switch :checkedValue="1" :unCheckedValue="0" checked-children="启用" un-checked-children="禁用" v-model:checked="record.status" />
        </template>
        <template v-slot:action>
          <a href="javascript:;">预览核销码</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getAgentList } from "@/api/agent";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    keywords: "",
    address: '',
    level_id: undefined,
    page: 1,
    limit: 10,
    start_time: '',
    end_time: '',
    select: ''
  };
  export default {
    components: {  },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([
        {
          id: 1,
          name: `Edward King `,
          age: 32,
          address: `London, Park Lane no. `,
          status:false
        },
        {
          id: 2,
          name: `Edward King `,
          age: 32,
          address: `London, Park Lane no. `,
          status:true
        }
      ]);
      const state = reactive({
        cityList: require('@/utils/area.json'),
        listLoading: false,
        time: [],
        total: 1,
        selectedRowKeys: [],
      });
      let columns = [
        {
          title: "门店编号",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "门店名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "门店地址",
          dataIndex: "age",
          key: "age",
        },
        {
          title: "负责人",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "所属上级",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "手机号",
          dataIndex: "balance",
          key: "balance",
        },
        {
          title: "门店类型",
          dataIndex: "signing_time",
          key: "signing_time",
        },
        {
          title: "门店状态",
          dataIndex: "signing_time",
          key: "signing_time",
        },
        {
          title: "店码状态",
          key: "status",
          slots: { customRender: "status" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const momentTime = inject('momentTime')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //删除代理商
      const agentDel = (e) => {
        // $Modal.confirm({
          // centered:true,
        //   content: '删除后该代理商将无法恢复，您确定要删除该代理商吗？', onOk:async () => {
        //     let res = await setAgentDel(e.id).then(res => res.data);
        //     if (iscode(res)) {
        //       message.success(res.msg);
        //       initData(search.value);
        //     }else {
        //       message.error(res.msg);
        //     }
        //   }
        // })
      }
      //批量选中
      const onSelectChange = (selectedRowKeys) => {
        state.selectedRowKeys = selectedRowKeys;
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getAgentList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      //选择省市区
      const onChangeAddress = (e) => {
      }

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        // initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        momentTime,
        agentDel,
        onSelectChange,
        onChangeAddress
      };
    },
  };
</script>